import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isNotEmptyString, isValidEmail } from "../utils/common/validate";
import { DefaultMessages, ErrorMessages } from "../utils/constants/Labels";
import { generateLog } from "../utils/constants/Logger";
import { logo } from '../assets/images/logo.png';
import {
  showToastError,
  showToastSuccess,
} from "../utils/common/ToastController";
import { appGalleryService } from "../services/ApiService";
import "../App.css";
import Layout from "./common/Layout";

function SignUp() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errors, setErrors] = useState({});
  const [isSignUpMode, setIsSignUpMode] = useState(true); // Set default mode to sign up

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      default:
        break;
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = { email: "", password: "" };

    if (!isNotEmptyString(email)) {
      newErrors.email = ErrorMessages.EmailRequired;
    } else if (!isValidEmail(email)) {
      newErrors.email = ErrorMessages.InvalidEmail;
    }
    if (!isNotEmptyString(firstName)) {
      newErrors.firstName = ErrorMessages.firstnameRequired;
    }
    if (!isNotEmptyString(lastName)) {
      newErrors.lastName = ErrorMessages.LastNameRequired;
    }

    if (!isNotEmptyString(password)) {
      newErrors.password = ErrorMessages.PasswordRequired;
    }

    setErrors(newErrors);

    if (Object.values(newErrors).every((error) => error === "")) {
      let payLoad = {
        Firstname: firstName,
        Lastname: lastName,
        Email: email,
        Password: password,
      };
      console.log("Submitting form with values:", payLoad);
      appGalleryService
        .signUp(payLoad)
        .then((response) => {
          console.log("Full API Response:", response);
          generateLog("default", SignUp.name, "Sign-Up API Response", response);

          if (response.Status === true) {
            showToastSuccess(DefaultMessages.SuccessLogin);
            navigate("/LandingPage");
          } else {
            showToastError(response.message);
          }
        })
        .catch((error) => {
          generateLog("error", SignUp.name, "Sign-Up API Error", error);
        });
    }
  };

  return (
    <Layout pageName="sidenav">
      <div className="row mt-5">
        <div className="col-4">
          <div className="card-ai-for-support">
            <div className="d-flex align-items-center">
              <div className="me-1">
                <h6 className="fs-18 fw-bold">Flex</h6>

                <p className="txt-dove-grey fs-12">
                  A customisable business chatbot platform that offers greater user engagement.
                </p>
              </div>
              <div className="d-flex justify-content-start">
                <img
                  src="logo-flex.png"
                  alt=""
                  width="100"
                  height="66"
                  className="grayscale-1 mb-4"
                />
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="card-ai-workflow">
              <h6 className="text-center">AI Workflows</h6>
            </div>
            <div className="card-ai-for-distribuiton-networks">
              <h6 className="m- mb-1 fs-18 fw-bold">Social</h6>
              <p className="txt-dove-grey m-0 fs-12 mb-3">
                Connect Privately, Share Securely: Your Exclusive Community Space.
              </p>
              <div className="d-flex justify-content-start">
                <img
                  src="social.png"
                  alt=""
                  width="98"
                  height="56"
                  className="grayscale-1"
                />
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="card-custom-gpts">
              <h6 className="text-center">Custom GPTs</h6>
            </div>
            <div className="card-ai-for-sales-team">
              <h6 className="fw-bold fs-18">Steno</h6>
              <p className="txt-dove-grey fs-12 mb-2">
                An AI-powered translator plugin that eliminates language barriers.
              </p>
              <div className="d-flex justify-content-start pt-0">
                <img
                  src="steno.png"
                  alt=""
                  width="101"
                  height="60"
                  className="grayscale-1"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="card-procurement-ai-solution">
            <h6 className=" fw-bold fs-18">
              Elevate
            </h6>
            <p className="txt-dove-grey fs-12">
              A secure, intelligent advanced GPT style chatbot to enhance productivity.
            </p>
            <div className="d-flex justify-content-start">
              {" "}
              <img
                src="elevate.png"
                alt=""
                width="100"
                height="58"
                className="grayscale-1"
              />
            </div>
          </div>
          <div className="card-ai-data-transformation">
            <div className="d-flex justify-content-between">
              <div>
                <h6 className="fw-bold fs-18">
                  Collab
                </h6>
                <p className="txt-dove-grey fs-12">
                  An AI-embedded collaboration portal helping communities of users.
                </p>
              </div>
              <img
                src="Collab.png"
                alt=""
                width="130"
                height="58"
                className="grayscale-1 mt-3"
              />
            </div>
          </div>
          <div className="card-ai-data-transformation">
            <div className="d-flex justify-content-between">
              <div>
                <h6 className="fw-bold fs-18">
                  Grasp
                </h6>
                <p className="txt-dove-grey fs-12">
                  An AI document and image reader that streamlines data transformation.
                </p>
              </div>
              <img
                src="logo-grasp.png"
                alt=""
                width="150"
                height="58"
                className="grayscale-1 mt-3"
              />
            </div>
          </div>
          {/* <div className="d-flex">
            <div className="card-ai-document-reader mr-16">
              <h6 className=" fw-bold fs-18">
                Grasp
              </h6>
              <p className="txt-dove-grey fs-12 m-0">
                
              </p>
              <div className=" d-flex justify-content-end">

              </div>
            </div>
            <div className="card-translation-ai d-flex  align-items-center">
              <img
                src="logo-grasp.png" className="d-flex mx-auto align-items-center grayscale-1 mt-3"
                alt=""
                width="100"
                height="61"
              />
            </div>
          </div> */}
        </div>
        <div className="col-4">
          <div className="login-card">
            <h5>
              <i>Empowering</i>
              <span className="mb-28">
                <i>
                  Growth Through <b>AI</b>
                </i>
              </span>
            </h5>

            <form onSubmit={submitHandler}>
              <div className="form-group">
                <label className="txt-dark-junglee-green fs-12">First Name</label>
                <input
                  type="text"
                  className={`form-control ${errors.firstName ? 'error-border' : ''}`}
                  placeholder="Enter First Name"
                  name="firstName"
                  value={firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <div className="error-message text-danger">{errors.firstName}</div>
                )}
              </div>
              <div className="form-group">
                <label className="txt-dark-junglee-green fs-12">Last Name</label>
                <input
                  type="text"
                  className={`form-control ${errors.lastName ? 'error-border' : ''}`}
                  placeholder="Enter Last Name"
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                />
                {errors.lastName && (
                  <div className="error-message text-danger">{errors.lastName}</div>
                )}
              </div>
              <div className="form-group">
                <label className="txt-dark-junglee-green fs-12">Email</label>
                <input
                  type="email"
                  className={`form-control ${errors.email ? 'error-border' : ''}`}
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className="error-message text-danger">{errors.email}</div>
                )}
              </div>
              <div className="form-group">
                <label className="txt-dark-junglee-green fs-12">Password</label>
                <input
                  type="password"
                  className={`form-control ${errors.password ? 'error-border' : ''}`}
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={handleChange}
                />
                {errors.password && (
                  <div className="error-message text-danger">{errors.password}</div>
                )}
              </div>

              <button type="submit" className="btn orange-btn mt-26 mb-8">
                Sign Up
              </button>
              <h6 className="text-center">
                <a className="text-decoration-underline text-dark" href="./signin">Back To Login</a>
              </h6>

            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SignUp;
